import React, { useEffect, useState, useContext } from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';
import { useParams } from 'react-router-dom';
import { AuthContext } from '../helpers/AuthContex';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import CommissionTable from '../component/CommissionTable';
import { transformData, generateDateRange } from '../utils/commissionUtils';

axios.defaults.headers.common['accessToken'] = Cookies.get('accessToken');
axios.defaults.headers.post["Content-Type"] = "application/json";

const ComissionHandFee = () => {
  const { startDate, endDate, id } = useParams();
  const { authState } = useContext(AuthContext);

  const [employee, setEmployee] = useState();
  const [comission, setComssion] = useState();
  const [optimizeData, setOptimizeData] = useState();
  const [dateRange, setDateRange] = useState([]);
  const [isLoading, setLoading] = useState(true);

  const padWithZero = (value) => value.toString().padStart(2, '0');

  // Determine if this is a range view or monthly view
  const isRangeView = startDate && endDate;

  useEffect(() => {
    const fetchdata = async () => {
      try {
        const employeeResponse = await axios.get(
          process.env.REACT_APP_API_URL + `/employee/byId/${authState.department_id}`,
          { headers: { accessToken: Cookies.get('accessToken') } }
        );
        setEmployee(employeeResponse.data);

        let apiUrl;
        let dateRange;

        if (isRangeView) {
          // Range view: use startDate and endDate from params
          apiUrl = process.env.REACT_APP_API_URL + `/comission/get-comission-handfee/byDp&Range/${authState.department_id}/${startDate}/${endDate}`;

          const [Sdate, Smonth, Syear] = startDate.split('-');
          const [Edate, Emonth, Eyear] = endDate.split('-');
          const startDateS = `${Syear}-${padWithZero(Smonth)}-${padWithZero(Sdate)}`;
          const endDateS = `${Eyear}-${padWithZero(Emonth)}-${padWithZero(Edate)}`;
          dateRange = generateDateRange(startDateS, endDateS);
        } else {
          // Monthly view: use id param (month-year format)
          apiUrl = process.env.REACT_APP_API_URL + `/comission/get-comission-month-handfee/byDp&Date/${authState.department_id}/${id}`;

          const [month, year] = id.split('-');
          const startDate = `${year}-${month}-01`;
          const endDate = new Date(year, month, 0).getDate();
          dateRange = generateDateRange(startDate, `${year}-${month}-${endDate}`);
        }

        const comissionResponse = await axios.get(apiUrl, {
          headers: { accessToken: Cookies.get('accessToken') }
        });
        setComssion(comissionResponse.data);

        // Pass raw commission data directly to CommissionTable
        // CommissionTable will handle the transformation internally
        const rawCommissionData = comissionResponse.data;

        // Add the mysterious date for complete date range
        const completeDateRange = [...dateRange, '29/02/2567'];

        setOptimizeData(rawCommissionData);
        setDateRange(completeDateRange);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching commission data:', error);
        setLoading(false);
      }
    };

    fetchdata();
  }, [startDate, endDate, id, authState.department_id, isRangeView]);

  if (isLoading) {
    return (
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open>
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  }

  return (
    <>
      <div className='flex items-end justify-center mt-2'>
        <h5 className='md:text-[3rem] text-[2rem] mb-[10px]'>สรุปค่ามือ</h5>
      </div>
      <div className='md:p-[24px] md:bg-[#E77B7C] md:shadow-2xl md:mx-[10rem] mx-[0.5rem] rounded-xl mb-10'>
        <div className={`md:px-[24px] px-[0.5rem] pt-[24px] bg-white shadow-2xl rounded-xl pb-[24px]`}>
          <CommissionTable employeeData={employee} optimizeData={optimizeData} dateRange={dateRange} />
        </div>
      </div>
    </>
  );
};

export default ComissionHandFee;
